import React from 'react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function FinalCTA() {
  return <section className="w-full bg-plum-deep" data-id="element-152" data-mp="5f3fysd94bms">
      <div className="mx-auto w-full max-w-3xl px-5 py-14 sm:px-8 sm:py-20" data-id="element-153" data-mp="3msqqgbhvk4nu">
        <h2 className="text-balance text-center font-display text-[29px] font-black leading-[1.1] tracking-[-0.02em] text-white sm:text-4xl" data-id="element-154" data-mp="3rsbliatxbsva">
          La tua prossima consultazione sulla menopausa non deve essere incerta.
        </h2>

        <div className="mt-6 space-y-2 text-center text-[15.5px] leading-relaxed text-white/70 sm:text-lg" data-id="element-155" data-mp="3hw8n9g270edm">
          <p data-id="element-156" data-mp="33wqtema1iaxe">Non hai bisogno di un altro manuale.</p>
          <p data-id="element-157" data-mp="38th8b6a3z0h8">Non hai bisogno di un’altra linea guida.</p>
          <p className="font-semibold text-white" data-id="element-158" data-mp="38w3fv5x01fzg">
            Hai bisogno di un sistema clinico che ti aiuti a prendere la decisione giusta, ogni
            singola volta.
          </p>
        </div>

        <div className="mt-9 rounded-3xl bg-white/[0.07] p-6 ring-1 ring-white/20 sm:p-8" data-id="element-159" data-mp="170jizkfjiq11">
          <p className="text-center text-[11.5px] font-extrabold uppercase tracking-[0.2em] text-gold" data-id="element-160" data-mp="q6iulfol8ymk">
            Solo oggi
          </p>
          <p className="mt-2 text-center font-display text-[72px] font-black leading-none text-white sm:text-8xl" data-id="element-161" data-mp="z1grsyyrqxjp">
            19 €
          </p>
          <p className="mt-2 text-center text-[13px] font-medium text-white/55 sm:text-sm" data-id="element-162" data-mp="uzvg3gxz0pb3">
            Cambio di moneta automatico nella tua valuta locale
          </p>

          <div className="mt-6" data-id="element-163" data-mp="2bpxp0ue3cef">
            <CTAButton label="Sì, voglio il progetto completo" variant="gold" data-id="element-164" data-mp="2ciupa3jqnjd" />
          </div>

          <div className="mt-6" data-id="element-165" data-mp="gbqxecyx4dsb">
            <Countdown tone="dark" data-id="element-166" data-mp="bbcqwzcytbwe" />
          </div>

          <div className="mt-5" data-id="element-167" data-mp="b9t7izw0ikqe">
            <ScarcityBar tone="dark" data-id="element-168" data-mp="bdpebs1hsegu" />
          </div>

          <p className="mt-5 text-center text-[12.5px] font-medium leading-relaxed text-white/50" data-id="element-169" data-mp="1rob8rlwdnesf">
            Accesso Immediato • Pagamento Una Tantum • Accesso a Vita • Garanzia Soddisfatti o
            Rimborsati di 7 Giorni
          </p>
        </div>
      </div>
    </section>;
}